import Vue from 'vue'
import VueCookies from 'vue-cookies-reactive'

Vue.use(VueCookies)
